export default {
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
  },
  setLastRoute (state, route) {
    state.lastRoute = route
  },
  /**
   *
   * @param state
   * @param keyvalue - debe ser un objeto con el formato: { attr: x, value: x }
   */
  putInStore (state, keyvalue) {
    state[keyvalue.attr] = keyvalue.value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js